module.exports = __webpack_public_path__ + "img/8984930de3c00650152bdb2c4e39d537.png";